import React from 'react'

import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded'
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded'
import LocalPoliceRoundedIcon from '@mui/icons-material/LocalPoliceRounded'

export const userRoleIconsMap: Record<number, React.ReactNode> = {
    0: <LocalPoliceRoundedIcon />,
    1: <AdminPanelSettingsRoundedIcon />,
    2: <AccountCircleRoundedIcon />,
}
export const roleLabels: Record<number, string> = {
    0: 'Super administrateur',
    1: 'Gestionnaire',
    2: 'Utilisateur',
}
export const roleDescriptions: Record<number, string> = {
    0: 'compte disposant d’un accès à toutes les fonctionnalités du “gestionnaire” et de la possibilité de modifier les comptes "gestionnaires".',
    1: 'compte disposant de privilèges (modifier établissement, visualiser et ajouter des utilisateurs).',
    2: 'compte sans priviliège.',
}
